import PerspectiveSelection from './PerspectiveSelection';
import { resetScope } from 'src/components/AssortmentScopeSelector/AssortmentScopeSelector.slice';
import { AppState, AppThunkDispatch } from 'src/store';
import { connect } from 'react-redux';
import serviceContainer from 'src/ServiceContainer';
import { Mode } from 'src/state/uipose/UiPose.slice';

export type StateProps = {
  darkMode: Mode;
};

export interface DispatchProps {
  resetScope: () => void;
}
export interface Props extends StateProps, DispatchProps {}

function mapStateToProps(state: AppState): StateProps {
  return {
    darkMode: state.uiPose.themeMode,
  };
}

function mapDispatchToProps(dispatch: AppThunkDispatch): DispatchProps {
  return {
    resetScope() {
      dispatch(resetScope());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PerspectiveSelection(serviceContainer.configService));
